var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwapIboaB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131,
    height: 30,
    viewBox: "0 0 131 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit_Category",
    transform: "translate(-339.283 -201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10413",
    "data-name": "Group 10413"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 131,
    height: 30,
    rx: 4,
    transform: "translate(339.283 201)",
    fill: "#b16d03"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7881",
    "data-name": "Group 7881",
    transform: "translate(349.283 207)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Swap_IBO_A_IBO_B",
    "data-name": "Swap IBO A & IBO B",
    transform: "translate(0 13)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "OpenSans, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Swap IBO A & IBO B")))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapIboaB);
export default __webpack_public_path__ + "static/media/SwapIBOA_B.eea2da91.svg";
export { ForwardRef as ReactComponent };